import React from 'react'
import './loader.css'

export default () => <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>